module.exports = __webpack_public_path__ + "static/media/barcelona.bd7d2904.jpg";